"use client";

import React from "react";
import ScrollArrow from "../../../../../public/images/New-landing/scroll-arrow.svg";

interface NavigationButtonProps {
  text: string;
  targetId: string;
  direction?: "up" | "down";
  className?: string;
  textClassName?: string;
  onClick?: () => void;
  isFirstSection?: boolean;
}

const NavigationButton: React.FC<NavigationButtonProps> = ({
  text,
  targetId,
  direction = "down",
  className = "",
  textClassName = "",
  onClick,
  isFirstSection = false,
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      const targetSection = document.querySelector(`#${targetId}`);
      targetSection?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleClick();
    }
  };


  const getArrowWrapperClasses = () => {
    const baseClasses = "arrow-bounce";
    const directionClasses = direction === "up" ? "arrow-bounce-down" : "arrow-bounce-up";
    const sectionClasses = isFirstSection ? "arrow-bounce-first" : "arrow-bounce-other";
    return `${baseClasses} ${directionClasses} ${sectionClasses}`.trim();
  };

  const getArrowClasses = () => {
    const directionClasses = direction === "up" ? "transform rotate-180" : "";
    return directionClasses;
  };

  const getTextClasses = () => {
    const baseClasses = "font-montserrat font-bold text-base tracking-[0.01em] text-[#031F47]";
    return `${baseClasses} ${textClassName}`.trim();
  };

  const getContainerClasses = () => {
    const baseClasses = "flex flex-col items-center gap-2 cursor-pointer";
    return `${baseClasses} ${className}`.trim();
  };

  return (
    <div
      className={getContainerClasses()}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-label={`Navigate to ${text}`}
    >
      {direction === "up" ? (
        <>
          <div className={getArrowWrapperClasses()}>
            <div className={getArrowClasses()}>
              <ScrollArrow />
            </div>
          </div>
          <span className={getTextClasses()}>{text}</span>
        </>
      ) : (
        <>
          <span className={getTextClasses()}>{text}</span>
          <div className={getArrowWrapperClasses()}>
            <div className={getArrowClasses()}>
              <ScrollArrow />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default NavigationButton;
